import ReactMarkdown from "react-markdown";
import styled from "styled-components/macro";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: auto;
  padding: 24px 32px;
  gap: 16px;
  box-sizing: border-box;
  background: var(--document-background);
`;

const Title = styled.h2`
  font-size: 20px;
  font-weight: 600;
  margin: 0 0 8px 0;
  color: var(--grey-0);
`;

const MessageList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Message = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const RoleLabel = styled.span`
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--grey-2);
`;

const MessageContent = styled.div`
  font-size: 14px;
  line-height: 1.6;
  color: var(--grey-0);

  p {
    margin: 0 0 8px 0;
    &:last-child {
      margin-bottom: 0;
    }
  }

  pre {
    background: var(--grey-6);
    border-radius: 4px;
    padding: 8px 12px;
    overflow-x: auto;
    font-size: 13px;
  }

  code {
    background: var(--grey-6);
    border-radius: 3px;
    padding: 1px 4px;
    font-size: 13px;
  }
`;

const EmptyState = styled.div`
  color: var(--grey-3);
  font-style: italic;
  font-size: 14px;
`;

export default function TrashedChat({ chat }) {
  const messages = (chat.messages || []).filter((m) => m.role === "user" || m.role === "assistant");

  return (
    <Container>
      <Title>{chat.title || "Untitled Chat"}</Title>
      {messages.length === 0 ? (
        <EmptyState>No messages in this chat.</EmptyState>
      ) : (
        <MessageList>
          {messages.map((message) => (
            <Message key={message.id}>
              <RoleLabel>{message.role === "user" ? "You" : "Sudowrite"}</RoleLabel>
              <MessageContent>
                <ReactMarkdown>{message.content}</ReactMarkdown>
              </MessageContent>
            </Message>
          ))}
        </MessageList>
      )}
    </Container>
  );
}
